
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4xGyI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $arWla = parcelRequire("arWla");

const $4bf082deedcaf06e$var$i18n = (0, $aXWIB.defineMessages)({
    viewMore: {
        id: "space-views.view.more",
        defaultMessage: "View more"
    }
});
const $4bf082deedcaf06e$export$c90319ae2a7816b4 = ({ fetchMore: fetchMore, hasMore: hasMore, loading: loading })=>{
    return !loading && hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arWla.MoreButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        spacing: "compact",
        shouldFitContainer: true,
        onClick: fetchMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4bf082deedcaf06e$var$i18n.viewMore))) : null;
};
module.exports["ViewMoreButton"] = $4bf082deedcaf06e$export$c90319ae2a7816b4;

});


//# sourceMappingURL=ViewMoreButton.94dae9a0.js.map
